import React from "react";
import {Allegato} from "./allegatiSlice";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

import IconButton from "@mui/material/IconButton";
import {Link} from "@mui/material";
import {Link as ReactLink} from "react-router-dom";
import {Routes_path} from "../routerApp";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import ScaleIcon from "@mui/icons-material/Scale";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import {convertToDateTime} from "../common/dateUtils/convertToDateTime";

interface AllegatiListProps {
    allegati: Allegato[];
    handleDelete: (allegato: Allegato) => void;
    consentiModifica?: boolean;
}

const AllegatiList = ({allegati, handleDelete, consentiModifica}: AllegatiListProps) => {
    return (
        <List dense={true}>
            {allegati?.map((allegato) => (
                <Box key={"box_allegato_" + allegato.id}>
                    <ListItem
                        key={"allegato_" + allegato.id}
                        secondaryAction={consentiModifica &&
                            <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => handleDelete(allegato)}
                            >
                                <DeleteIcon/>
                            </IconButton>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar component={Link} href={allegato.file} target="_blank">
                                <AttachFileIcon/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={allegato.tipo_documento_des?.nome}
                            secondary={allegato.descrizione|| "Nessuna descrizione"}
                        />
                    </ListItem>
                    <Divider variant="inset" component="li"/>
                </Box>
            ))}
        </List>
    );
};

export default AllegatiList;
